<mat-sidenav-container class="sidenav-container">
  <!-- LEFT MENU -->
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : sideNavMode"
    [opened]="(isHandset$ | async) === true || sideNavMode === 'side'"
    color="primary"
  >
    <div class="sidenav-header">
      <ng-content select="[sidenavheader]"></ng-content>
    </div>
    <div class="sidenav-menuleft">
      <ng-content select="[sidenavmenuleft]"></ng-content>
    </div>
  </mat-sidenav>

  <!-- CONTENT AREA -->
  <mat-sidenav-content>
    <div class="content-header">
      @if (alwaysShowToggle || (isHandset$ | async)) {
      <div
        class="header-toggle"
        aria-label="Toggle menu"
        (click)="drawer.toggle()"
      >
        <ng-content select="[headertoggle]"></ng-content>
      </div>
      }
      <div class="header-content">
        <ng-content select="[contentheader]"></ng-content>
      </div>
    </div>
    <div [ngStyle]="containerTheme">
      <ng-content select="[contentcontainer]"></ng-content>
    </div>
    <div [ngStyle]="footerTheme">
      <ng-content select="[contentfooter]"></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
